import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Users, Bell, BookOpen, FileText, Video, Star, LogOut } from 'lucide-react';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/batches', label: 'Batch Management', icon: Users },
  { path: '/notices', label: 'Notice Board', icon: Bell },
  { path: '/courses', label: 'Course Management', icon: BookOpen },
  { path: '/applications', label: 'Applications', icon: FileText },
  { path: '/videos', label: 'Video Management', icon: Video },
  { path: '/success-stories', label: 'Success Stories', icon: Star },
];

export default function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="w-64 min-h-screen bg-gradient-to-b from-red-800 to-red-950 flex flex-col fixed left-0 top-0 z-50 shadow-2xl">
      <div className="p-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-xl">🇯🇵</div>
          <div>
            <p className="text-white font-bold text-sm leading-tight">Skill to Japan BD</p>
            <p className="text-red-300 text-xs">Admin Panel</p>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-0.5">
        {navItems.map(({ path, label, icon: Icon }) => (
          <NavLink key={path} to={path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-all ${isActive ? 'bg-white/20 text-white font-semibold' : 'text-red-200 hover:bg-white/10 hover:text-white'}`}>
            <Icon size={17} /><span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <button onClick={() => { logout(); navigate('/login'); }}
          className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-red-200 hover:bg-white/10 hover:text-white transition-all w-full">
          <LogOut size={17} /><span>Logout</span>
        </button>
      </div>
    </div>
  );
}
